module.exports = __webpack_public_path__ + "img/grasse_3.0693222f.png";